import type { CSSProperties } from 'react'

// Skeleton leve, sem dependências. Inspirado no padrão shadcn/ui, mas minimal:
// não usamos a classe utilitária `.animate-pulse` do Tailwind (a app não usa Tailwind)
// — definimos `@keyframes fz-shimmer` em app.css.
//
// Princípio de UX: layout-reserving (não muda altura quando o conteúdo chega).
// `aria-busy="true"` + `aria-live="polite"` em volta + role="status" para que
// leitores de tela anunciem "Carregando…" sem inundar (só no mount, depois some).
//
// Onde usar:
//   <RowSkeleton /> — para listas (altura 56px por linha, 5 linhas)
//   <BlockSkeleton height={240} /> — para blocos (detalhes, modal)
//   <CircleSkeleton size={48} /> — para avatares / presence dots

interface RowSkeletonProps {
  count?: number
  ariaLabel?: string
}

export function RowSkeleton({ count = 5, ariaLabel = 'Carregando lista' }: RowSkeletonProps) {
  const rows = Array.from({ length: count })
  return (
    <div role="status" aria-busy="true" aria-live="polite" aria-label={ariaLabel} className="fz-skel-list">
      {rows.map((_, i) => (
        <div
          key={i}
          className="fz-skel fz-skel--row"
          style={{ '--i': Math.min(i, 6) } as CSSProperties}
        />
      ))}
    </div>
  )
}

interface BlockSkeletonProps {
  height?: number
  ariaLabel?: string
}

export function BlockSkeleton({ height = 240, ariaLabel = 'Carregando conteúdo' }: BlockSkeletonProps) {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-live="polite"
      aria-label={ariaLabel}
      className="fz-skel fz-skel--block"
      style={{ height } as CSSProperties}
    />
  )
}

interface CircleSkeletonProps {
  size?: number
  ariaLabel?: string
}

export function CircleSkeleton({ size = 48, ariaLabel = 'Carregando' }: CircleSkeletonProps) {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-live="polite"
      aria-label={ariaLabel}
      className="fz-skel fz-skel--circle"
      style={{ width: size, height: size } as CSSProperties}
    />
  )
}